(function () {
  'use strict';

  var INIT = 'data-lp-military-init';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToTarget(root, selector) {
    if (!selector) return;
    var target = root.querySelector(selector);
    if (!target) return;
    target.scrollIntoView({
      behavior: reducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function initScrollButtons(root) {
    root.querySelectorAll('[data-lp-military-scroll]').forEach(function (btn) {
      if (btn.getAttribute('data-lp-military-scroll-bound') === 'true') return;
      btn.setAttribute('data-lp-military-scroll-bound', 'true');
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToTarget(root, btn.getAttribute('data-lp-military-scroll'));
      });
    });
  }

  function initHero(root) {
    var hero = root.querySelector('[data-lp-military-hero]');
    if (!hero || hero.getAttribute('data-lp-military-hero-bound') === 'true') return;
    hero.setAttribute('data-lp-military-hero-bound', 'true');

    if (reducedMotion()) {
      hero.classList.add('is-ready');
      return;
    }

    requestAnimationFrame(function () {
      hero.classList.add('is-ready');
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('[data-lp-military-reveal]');
    if (!items.length) return;

    if (reducedMotion()) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

    items.forEach(function (el) {
      if (el.getAttribute('data-lp-military-reveal-bound') === 'true') return;
      el.setAttribute('data-lp-military-reveal-bound', 'true');
      io.observe(el);
    });
  }

  function initSteps(root) {
    var section = root.querySelector('[data-lp-military-steps]');
    if (!section || section.getAttribute('data-lp-military-steps-bound') === 'true') return;
    section.setAttribute('data-lp-military-steps-bound', 'true');

    var steps = section.querySelectorAll('[data-lp-military-step]');
    if (!steps.length) return;

    function activateSteps() {
      section.classList.add('is-animated');
      steps.forEach(function (step, index) {
        window.setTimeout(function () {
          step.classList.add('is-active');
        }, index * 80);
      });
    }

    if (reducedMotion()) {
      activateSteps();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        activateSteps();
        io.disconnect();
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

    io.observe(section);
  }

  function initGovxModule(root) {
    var module = root.querySelector('[data-lp-military-govx-module]');
    if (!module || module.getAttribute('data-lp-military-govx-bound') === 'true') return;
    module.setAttribute('data-lp-military-govx-bound', 'true');

    function showModule() {
      module.classList.add('is-visible');
    }

    if (reducedMotion()) {
      showModule();
      return;
    }

    var intro = root.querySelector('.lp-military-verify__intro');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        window.setTimeout(showModule, intro ? 200 : 0);
        io.disconnect();
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });

    io.observe(intro || module);
  }

  function initFaq(root) {
    var items = root.querySelectorAll('[data-lp-military-faq-item]');
    items.forEach(function (item) {
      if (item.getAttribute('data-lp-military-faq-bound') === 'true') return;
      item.setAttribute('data-lp-military-faq-bound', 'true');

      var trigger = item.querySelector('[data-lp-military-faq-trigger]');
      var panel = item.querySelector('[data-lp-military-faq-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');

        if (willOpen) {
          items.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var otherTrigger = other.querySelector('[data-lp-military-faq-trigger]');
            var otherPanel = other.querySelector('[data-lp-military-faq-panel]');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.hidden = true;
          });
        }

        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        panel.hidden = !willOpen;
      });
    });
  }

  function clearBindings(root) {
    var stepsSection = root.querySelector('[data-lp-military-steps]');
    if (stepsSection && stepsSection._lpMilStepsScroll) {
      window.removeEventListener('scroll', stepsSection._lpMilStepsScroll);
      window.removeEventListener('resize', stepsSection._lpMilStepsScroll);
      stepsSection._lpMilStepsScroll = null;
    }

    root.removeAttribute(INIT);
    root.querySelectorAll('[data-lp-military-scroll-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-military-scroll-bound');
    });
    root.querySelectorAll('[data-lp-military-hero-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-military-hero-bound');
    });
    root.querySelectorAll('[data-lp-military-reveal-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-military-reveal-bound');
    });
    root.querySelectorAll('[data-lp-military-steps-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-military-steps-bound');
    });
    root.querySelectorAll('[data-lp-military-govx-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-military-govx-bound');
    });
    root.querySelectorAll('[data-lp-military-faq-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-military-faq-bound');
    });
  }

  function initSection(root) {
    if (!root || root.getAttribute(INIT) === 'true') return;
    root.setAttribute(INIT, 'true');
    initScrollButtons(root);
    initHero(root);
    initReveal(root);
    initSteps(root);
    initGovxModule(root);
    initFaq(root);
  }

  function initAll() {
    document.querySelectorAll('[data-lp-military]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-military]');
    if (!root) return;
    clearBindings(root);
    initSection(root);
  });
})();
